<template>
  <v-card-title primary-title>
    <h4>Your details have been saved</h4>
  </v-card-title>
</template>

<script>
export default {
  components: {}
};

</script>
